import { Lightbulb } from "lucide-react";

/**
 * Investor annotation callout — amber accent for visibility.
 * Use for contextual insights that help investors interpret the data.
 */
export function Annotation({ children, className = "" }) {
  return (
    <div
      className={`flex gap-3 px-4 py-3 rounded-md border border-amber-800/40 bg-amber-950/20 ${className}`}
      data-testid="annotation"
    >
      <Lightbulb className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
      <p className="text-xs text-amber-200/90 leading-relaxed">{children}</p>
    </div>
  );
}

/**
 * Compact inline annotation for tight spaces (tables, cards).
 */
export function InlineAnnotation({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] text-amber-300/80 bg-amber-950/25 border border-amber-900/30 rounded px-2 py-1 ${className}`}
      data-testid="inline-annotation"
    >
      <Lightbulb className="w-3 h-3 text-amber-400 flex-shrink-0" />
      {children}
    </span>
  );
}

/**
 * Section-level annotation banner.
 */
export function AnnotationBanner({ title, children, className = "" }) {
  return (
    <div
      className={`rounded-md border border-amber-800/30 bg-gradient-to-r from-amber-950/30 to-amber-950/10 px-5 py-4 ${className}`}
      data-testid="annotation-banner"
    >
      {title && (
        <div className="flex items-center gap-2 mb-2">
          <Lightbulb className="w-4 h-4 text-amber-400" />
          <span className="text-xs font-semibold text-amber-300 uppercase tracking-wider">{title}</span>
        </div>
      )}
      <div className="text-xs text-amber-200/80 leading-relaxed space-y-1.5">{children}</div>
    </div>
  );
}
